import React, { useContext, useState, useEffect } from 'react'
import PrimaryButton from '../../../components/atoms/PrimaryButton'
import SecondaryButton from '../../../components/atoms/SecondaryButton'
import FullScreenPopup from '../../../components/organisms/FullScreenPopup'
import { mapData } from '../../../common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import SettingContext from '../../../context/setting/settingContext'
import { useLocation } from 'react-router-dom'

const BidIncrementManage = (props) => {
    const search = useLocation().search
    const edit = new URLSearchParams(search).get('edit')

    const settingContext = useContext(SettingContext)
    const [isLoading, setIsLoading] = useState(false)
    const { single_bid_increment, getSingleBidIncrement, bidIncrementAction } =
        settingContext
    const [reload, setReload] = useState(false)
    const data = props.data
    const toggleFullScreenPopup = props.function

    let validationArray = Yup.object({
        increment: Yup.number().integer().min(1).required('Required!'),
        from_amount: Yup.number().integer().min(0).required('Required!'),
        to_amount: Yup.number()
            .integer()
            .moreThan(
                Yup.ref('from_amount'),
                'To Amount must be more than From Amount'
            )
            .max(10000000000)
            .required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            from_amount: 0,
            to_amount: 0,
            increment: 0,
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            console.log('values', values)
            bidIncrementAction(values)
        },
    })

    useEffect(() => {
        if (data.status === 'edit') {
            formik.values.id = data.id
            getSingleBidIncrement(formik.values)
        } else {
            resetFrom()
        }
    }, [data.id])

    useEffect(() => {
        if (single_bid_increment.record && data.status === 'edit') {
            const template = single_bid_increment.record
            formik.setFieldValue('id', template.id)
            formik.setFieldValue('from_amount', template.from_amount || 0)
            formik.setFieldValue('to_amount', template.to_amount || 0)
            formik.setFieldValue('increment', template.increment || 0)
            setReload(!reload)
        } else {
            resetFrom()
        }
        setIsLoading(false)
    }, [single_bid_increment])

    const resetFrom = () => {
        formik.setFieldValue('id', 0)
        formik.setFieldValue('from_amount', 0)
        formik.setFieldValue('to_amount', 0)
        formik.setFieldValue('increment', 0)
    }

    const inputVariables = [
        {
            label: 'From Amount *',
            placeholder: 'Enter From Amount',
            class: 'col-12 mb-4',
            type: 'number',
            disabled: data.status === 'new' || edit === '1' ? false : true,
            shrink: true,
            name: 'from_amount',
            formik: formik,
            min: 0,
        },
        {
            label: 'To Amount *',
            placeholder: 'Enter To Amount',
            class: 'col-12 mb-4',
            disabled: data.status === 'new' || edit === '1' ? false : true,
            type: 'number',
            shrink: true,
            name: 'to_amount',
            formik: formik,
        },
        {
            label: 'Increment Value *',
            placeholder: `Enter Bid Increment Value`,
            class: 'col-12',
            name: 'increment',
            type: 'number',
            formik: formik,
            min: 1,
        },
    ]

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'ADD  BID INCREMNET'
                    : `EDIT BID INCREMNET`
            }
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        <div className="row">{mapData(inputVariables)}</div>
                        {isLoading && <div>Loading...</div>}
                        <div className="actionButton d-flex justify-content-center align-items-center">
                            <SecondaryButton
                                id="bidIncrements_cancel"
                                label="Cancel"
                                onClick={() => toggleFullScreenPopup(false)}
                            />
                            <PrimaryButton
                                id="bidIncrements_submit"
                                type="submit"
                                label="Submit"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default BidIncrementManage
